query getBrickArtDesign($id: ID!) {
  brickArtDesign(id: $id) {
    sourceImageUrl
    sourceImageKey
    faceBoundingBoxes {
      x
      y
      width
      height
    }
    backgroundMaskImageUrl
    colorisationImageUrl
    enhanceFacesImageUrl
    posteriseImage {
      type
      url
      message
    }
    variantPictures {
      # ...pictureConfigurationOutput fragment, but couldn't get working with client
      updatedAt

      imageZoom
      imageZoomOffset {
        x
        y
      }

      basePlateSize
      numberOfBasePlates {
        width
        height
      }

      brightness
      contrast
      saturation

      detailFilter {
        strength
        radiusRatio
      }
      dithering {
        serpentine
        clamp
        strength
      }

      removeBackground {
        newColour
      }
      enhanceFaces
      fixFaceColours

      paletteMode {
        type
        numberOfColours
        palette
      }

      pen {
        type
        value
      }
    }
  }
}
